import angular from "angular";
import template from "./admin-verify-students.html";
import AdminStudentsVerificationController from "./admin-verify-students.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.students.verification", {
    url: "/verification",
    controller: AdminStudentsVerificationController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.staff,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.students.verification", [])
  .config(config)
  .controller(
    "AdminStudentsVerificationController",
    AdminStudentsVerificationController,
  );
